import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import api from '../../api';

const SearchResults = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search).get("q") || "";
    
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAndFilter = async () => {
            setLoading(true);
            try {
                // Fetch ALL products
                const response = await api.get('/products/hiddenFalse');
                const allProducts = response.data || [];

                // Filter Client Side
                const filtered = allProducts.filter(p => 
                    (p.productName && p.productName.toLowerCase().includes(query.toLowerCase())) ||
                    (p.category && p.category.toLowerCase().includes(query.toLowerCase()))
                );
                
                setProducts(filtered);
            } catch (error) {
                console.error("Search error", error);
            } finally {
                setLoading(false);
            }
        };

        if(query) fetchAndFilter();
    }, [query]);

    if (loading) return <div className="text-center py-5"><h3>Searching...</h3></div>;

    return (
        <div className="container py-5" style={{minHeight:'80vh'}}>
            <h2 className="mb-4">Search Results for "{query}"</h2>
            
            {products.length === 0 ? (
                <div className="text-center py-5 bg-light rounded">
                    <h4>No products found matching your search.</h4>
                    <Link to="/our-shop" className="btn btn-warning mt-3">Browse Shop</Link>
                </div>
            ) : (
                <div className="row">
                    {products.map(item => {
                        // 🟢 FIX: Robust Image Logic (Matches Ourshop.js)
                        const image = (item.productPhotos && item.productPhotos.length > 0) 
                            ? (item.productPhotos[0].photoName || item.productPhotos[0]) 
                            : "/assets/images/Rectangle 129.png";

                        return (
                            <div key={item.productId} className="col-6 col-md-3 mb-4">
                                <Link to={`/product/${item.productId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <div className="card h-100 border-0 shadow-sm product-card">
                                        <div className="p-3 text-center" style={{ height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9f9f9' }}>
                                            <img 
                                                src={image} 
                                                alt={item.productName} 
                                                className="img-fluid" 
                                                style={{ maxHeight: '180px', objectFit: 'contain' }}
                                                // 🟢 FIX: Fallback if image breaks
                                                onError={(e) => {
                                                    e.target.onerror = null; 
                                                    e.target.src="/assets/images/Rectangle 129.png";
                                                }}
                                            />
                                        </div>
                                        <div className="card-body text-center">
                                            <h6 className="card-title fw-bold mb-1">{item.productName}</h6>
                                            <h5 className="fw-bold text-dark">₹{item.productPrice || item.price}</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default SearchResults;